<template>
  <div class="loading-box">
    <div class="loading">
      <div class="shape shape-4">
        <div class="shape-4-top"></div>
        <div class="shape-4-bottom"></div>
        <div class="shape-4-eye"></div>
      </div>
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
  </div>
</template>
<script>
import { getWxToken } from "@/api/active/active";
import { Dialog } from "vant";
export default {
  name: "WxLogin",
  data() {
    return { code: "", showData: {} };
  },
  created() {
    // if (this) return;
    this.toLogin();
  },
  methods: {
    linkTo() {
      const randomNumber = Math.floor(Math.random() * 21) + 1;
      window.location.replace(
        "https://m.wtjy.com/#/activityAnswer/question" + randomNumber
      );
    },
    getWxTokenFn(code) {
      getWxToken({ code: code })
        .then((res) => {
          // console.log();
          // this.showData = res;
          if (res.data.openid) {
            localStorage.setItem("wxOpenid", res.data.openid);
            // this.$router.push({
            //   name: "/activityAnswer/question",
            // });
            this.linkTo();
            // window.open('https://m.wtjy.com')
          } else {
            Dialog({
              message: "微信登录失败,请联系管理员或者重新进入页面尝试",
            });
            // Toast.fail("微信登录失败!");
            localStorage.setItem("wxOpenid", "");
          }
        })
        .catch(() => {
          Dialog({ message: "微信登录失败,请联系管理员或者重新进入页面尝试" });
          localStorage.setItem("wxOpenid", "");
        });
    },
    toLogin() {
      let wxOpenid = localStorage.getItem("wxOpenid");
      if (wxOpenid) {
        // this.$router.push({
        //   name: "/activityAnswer/question",
        // });
        this.linkTo();
        return;
      }
      const urlData = new URLSearchParams(window.location.search);
      // const code = "031nc01w3WmSz43I4H1w3A5X2n3nc01w";
      const code = urlData.get("code");
      if (code) {
        // console.log(this.$route.query.code);
        this.code = code;
        this.getWxTokenFn(code);
      } else {
        // console.log(window.location.href.split("#")[0]);
        let url = "https://m.wtjy.com/#/wx/wxLogin";
        // 示例：假设当前页面URL是你设置的回调地址
        const currentUrl = url;
        window.location.href = this.getAuthorizeUrl(currentUrl);
      }
    },
    getAuthorizeUrl(redirectUri, state = "") {
      const appId = "wx7cbd7ff9855f3660"; // 替换为你的AppID
      const scope = "snsapi_base"; // 或者'snsapi_userinfo'根据需求选择
      return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
        redirectUri
      )}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background-color: #e1e8f2;
}

.loading {
  width: 30px;
  height: 30px;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.loading .title {
  text-align: center;
  color: #101011;
  font-size: 14px;
  margin-bottom: 8px;
}

.loading .sub-title {
  font-size: 14px;
  color: #ff6936;
  line-height: 20px;
}

.shape {
  width: 10px;
  height: 10px;
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  background-color: #1875e5;
  left: -5px;
  animation: animationShape1 7s linear infinite;
}

.shape-2 {
  background-color: #c5523f;
  left: 15px;
  animation: animationShape2 7s linear infinite;
}

.shape-3 {
  background-color: #499255;
  left: 35px;
  animation: animationShape3 7s linear infinite;
}

.shape-4 {
  background-color: #f2b736;
  width: 30px;
  height: 30px;
  left: -40px;
  background-color: transparent !important;
  z-index: 2;
  animation: animationShape4 7s linear infinite;
}

.shape-4 > div {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.shape-4 .shape-4-top {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fbbc05;
  clip: rect(0 30px 15px 0);
  transform: rotate(-30deg);
  animation: animationShape4Top 0.4s ease infinite alternate;
}

.shape-4 .shape-4-bottom {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fbbc05;
  clip: rect(15px 30px 30px 0);
  transform: rotate(45deg);
  animation: animationShape4Bottom 0.4s ease infinite alternate;
}

.shape-4 .shape-4-eye {
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  position: absolute;
  top: 5px;
  right: 10px;
}

@keyframes animationShape4Top {
  0% {
    transform: rotate(-30deg);
  }

  100% {
    transform: rotate(0);
  }
}

@keyframes animationShape4Bottom {
  0% {
    transform: rotate(45deg);
  }

  100% {
    transform: rotate(0);
  }
}

@keyframes animationShape1 {
  0% {
    opacity: 1;
  }

  17% {
    opacity: 1;
  }

  19% {
    opacity: 0;
  }

  30% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }

  85% {
    opacity: 1;
  }

  90% {
    opacity: 0;
  }

  95% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes animationShape2 {
  0% {
    opacity: 1;
  }

  20% {
    opacity: 1;
  }

  22% {
    opacity: 0;
  }

  35% {
    opacity: 0;
  }

  45% {
    opacity: 1;
  }

  75% {
    opacity: 1;
  }

  80% {
    opacity: 0;
  }

  90% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes animationShape3 {
  0% {
    opacity: 1;
  }

  27% {
    opacity: 1;
  }

  29% {
    opacity: 0;
  }

  40% {
    opacity: 0;
  }

  64% {
    opacity: 1;
  }

  65% {
    opacity: 1;
  }

  70% {
    opacity: 0;
  }

  80% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes animationShape4 {
  0% {
    left: -40px;
    transform: rotateY(0);
  }

  45% {
    left: 50px;
    transform: rotateY(0);
  }

  50% {
    left: 50px;
    transform: rotateY(180deg);
  }

  95% {
    left: -40px;
    transform: rotateY(180deg);
  }

  100% {
    left: -40px;
    transform: rotateY(0);
  }
}

.messageContainer {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999999;
}

.message-box {
  padding: 10px 16px;
  background-color: #333;
  color: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  min-width: 380px;
  margin-bottom: 12px;
  /* transition: 0.2 linear; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-box.success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}

.message-box.error {
  background-color: #fef0f0;
  border-color: #fef0f0;
  color: #f56c6c;
}

.message-box.show {
  animation: showInBox 0.4s linear;
}

.message-box.hidden-msg {
  animation: hideIn 0.4s linear;
}

@keyframes hideIn {
  0% {
    opacity: 1;
    margin-top: 0;
  }

  100% {
    opacity: 0;
    margin-top: -30px;
  }
}

@keyframes showInBox {
  0% {
    opacity: 0;
    margin-top: -30px;
  }

  100% {
    opacity: 1;
    margin-top: 0;
  }
}

/* CSS样式 */
.modal-box {
  display: none;
  /* 默认隐藏 */
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-box .modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  border-radius: 4px;
}

.modal-box .modal-box-msg {
  padding: 18px;
}

.modal-box .close {
  font-size: 16px;
  font-weight: bold;
  color: #909399;
}

.modal-box .modal-header-box {
  font-weight: bold;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px;
  border-bottom: 1px solid #ededef;
}

.modal-box-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 18px;
  border-top: 1px solid #ededef;
}

.modal-box .close:hover,
.modal-box .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-box .add-table select {
  height: 24px;
  padding: 0 5px;
  border: 1px solid #d1cbcb;
  border-radius: 3px;
  margin: 5px;
}
</style>
